import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import './TestMiddleBanner.css';
import { NavLink } from 'react-router-dom';

import slide01 from "./assets/gif-slide-1.gif";
import slide02 from "./assets/gif-slide-2.gif";
import slide03 from "./assets/gif-slide-3.gif";

import car3 from "./assets/car2.png";
import car11 from "./assets/car11.png";
import car2 from "./assets/car3.png";

const slides = [
    {
        backg: slide01,
        carsparcle: car3,
        maintitle: "Find the Best Deals Today",
        maindescription: "Explore thousands of cars with AutoTrader",
        mainbutton: "Search now",
    },
    {
        backg: slide02,
        carsparcle: car11,
        maintitle: "Drive Away with Confidence",
        maindescription: "Comprehensive checks for your peace of mind",
        mainbutton: "Get Started",
    },
    {
        backg: slide03,
        carsparcle: car2,
        maintitle: "Your Dream Car Awaits",
        maindescription: "Fast, reliable, and secure purchase process",
        mainbutton: "Explore Now",
    },
];

const TestMiddleBanner = () => {
    const [index, setIndex] = useState(0);
    const slideRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline();

        const carEl = document.querySelector(`.carsparcle-${index}`);
        const bgEl = document.querySelector(`.backg-${index}`);
        const textEl = document.querySelector(`.text-${index}`);
        const btnEl = document.querySelector(`.btn-${index}`);

        if (!carEl || !bgEl || !textEl || !btnEl) return;

        // Reset elements
        gsap.set([carEl, bgEl, textEl, btnEl], { clearProps: "all" });

        const animateSlide = () => {
            tl.fromTo(bgEl, { opacity: 0 }, { opacity: 1, duration: 0.3 });
            if (index === 0) {
                tl.from(carEl, { x: -300, opacity: 0, duration: 0.8 });
                tl.from(textEl, { y: -50, opacity: 0, duration: 0.6 });
                tl.from(btnEl, { x: 100, opacity: 0, duration: 0.6 });
            } else if (index === 1) {
                tl.from(carEl, { scale: 0.5, opacity: 0, rotate: 180, duration: 0.8 });
                tl.from(textEl, { x: 50, opacity: 0, duration: 0.6 });
                tl.from(btnEl, { y: 100, opacity: 0, duration: 0.6 });
            } else {
                tl.from(carEl, { x: 300, opacity: 0, duration: 0.8 });
                tl.from(textEl, { x: -50, opacity: 0, duration: 0.6 });
                tl.from(btnEl, { y: 100, opacity: 0, duration: 0.6 });
            }
        };

        // Load and animate
        if (!carEl.complete) {
            carEl.onload = () => requestAnimationFrame(animateSlide);
        } else {
            requestAnimationFrame(animateSlide);
        }

        const timer = setTimeout(() => {
            setIndex((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => {
            clearTimeout(timer);
            tl.kill();
        };
    }, [index]);

    const handlePrev = () => {
        setIndex((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const handleNext = () => {
        setIndex((prev) => (prev + 1) % slides.length);
    };

    return (
        <div className="bannerslider" ref={slideRef}>
            {slides.map((slide, i) => (
                <div
                    key={i}
                    className={`slide ${i === index ? "active" : ""}`}
                    style={{ backgroundImage: `url(${slide.backg})` }}
                >
                    <div className={`backg-overlay backg-${i}`}></div>
                    <img src={slide.carsparcle} className={`carsparcle carsparcle-${i}`} alt="Car" />
                    <div className={`slide-text text-${i}`}>
                        <h1>{slide.maintitle}</h1>
                        <p>{slide.maindescription}</p>
                        <NavLink to="/contact-us" className="nav-link">
                            <button className={`btn btn-${i}`}>{slide.mainbutton}</button>
                        </NavLink>
                    </div>
                </div>
            ))}
            <button className="custom-arrow prev-arrow" onClick={handlePrev}>
                ←
            </button>
            <button className="custom-arrow next-arrow" onClick={handleNext}>
                →
            </button>
        </div>
    );
};

export default TestMiddleBanner;